import { Box, Typography } from "@mui/joy";
import Add from "@mui/icons-material/Add";
import React, { useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import GenericTableView from "../../components/GenericTableView";
import { FilterMatchMode } from "primereact/api";
import {
  GenericTableColumTypes,
  GenericTableFilterTypes,
} from "../../enum/TableView";
import { v4 as uuid } from "uuid";
import { GenericTableColumns } from "../../models/GenericTableViewModel";
import { removeClient } from "../../service/clientService";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { RouteComponentProps } from "../../models/RouteComponent";
import { removeEquipmentList } from "../../service/equipmentListService";
import {
  addRiskAssessment,
  getRiskAssessmentReport,
  removeRiskAssessment,
} from "../../service/riskAssessmentService";
import { Grid } from "@mui/material";
import { Button } from "primereact/button";
import { generatePdf } from "../../service/pdfGenerator";
import RiskHazardAdd from "./risk-hazard-Add";
import {
  addRiskHazard,
  removeRiskHazard,
} from "../../service/riskHazardService";

export default function RiskHazardView(props: RouteComponentProps) {
  const [selectedRecord, setSelectedRecord] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [preview, setPreview] = useState("");
  const toast = useRef(null as any);
  const dialog = useRef(null as any);

  const client_id = props?.session?.client_id;
  const site_id = props?.session?.site_id;

  const baseFilter = {
    type: { value: "", matchMode: FilterMatchMode.CONTAINS },
  };

  const deleteButton = (row: any) => {
    console.log("deleteButton row == ", selectedRecord);
    removeClient(selectedRecord.id);
  };

  const addButton = (row: any) => {
    console.log("addButton row == ", row);
    setSelectedRecord(null);
    setVisible(true);
  };

  const itemSelected = (row: any) => {
    console.log("itemSelected row == ", row);
    setSelectedRecord(row.value);
    editConfirm(row);
  };

  const contextItemSelected = (row: any) => {
    console.log("contextItemSelected row == ", row);
    setSelectedRecord(row.value);
  };

  const acceptFunc = async () => {
    props.setGlobalLoader(true);
    const industry = await removeRiskHazard(selectedRecord.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({
      severity: "success",
      summary: "Hazard Deleted Successfully",
      life: 3000,
    });
  };

  const editConfirm = (row: any) => {
    setVisible(true);
  };

  const deleteConfirm = (row: any) => {
    confirmDialog({
      message: "Are you sure you want to proceed?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => acceptFunc(),
    });
  };

  const unableToEdit = (row: any) => {
    toast.current.show({
      severity: "warning",
      summary: "Unable To Edit Hazard",
      life: 3000,
    });
  };

  const duplicate = (row: any) => {
    props.setGlobalLoader(true);
    addRiskHazard({
      name: `${selectedRecord.name} Duplicate`,
      description: selectedRecord.description,
      job_step: selectedRecord.job_step,
      client_id: client_id,
    })
      .then((r: any) => {
        toast.current.show({
          severity: "success",
          summary: "Hazard Created Successfully",
          life: 3000,
        });
        props.setGlobalLoader(false);
        setReload(!reload);
      })
      .catch((err) => {
        toast.current.show({
          severity: "error",
          summary: "Failed to Create Hazard",
          life: 3000,
        });
        props.setGlobalLoader(false);
      });
  };

  const contextItems = () => {
    let objArray: any[] = [];
    if (!site_id) {
      objArray.push({
        label: "Edit",
        icon: "pi pi-fw pi-pencil",
        command: editConfirm,
      });
      objArray.push({
        label: "Delete",
        icon: "pi pi-fw pi-trash",
        command: deleteConfirm,
      });
    } else {
      objArray.push({
        label: "View",
        icon: "pi pi-fw pi-eye",
        command: editConfirm,
      });
    }
    return objArray;
  };

  const columns: GenericTableColumns[] = [
    {
      field: "hazard_id",
      header: "Hazard ID",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "name",
      header: "Hazard",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "control_measure_list",
      header: "Control Measures",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "chemical_type_list",
      header: "Chemical Types",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "equipment_type_list",
      header: "Equipment Types",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "vehicle_type_list",
      header: "Vehicle Types",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    }
  ];

  if (client_id) {
    columns.splice(4, 0, {
      field: "type",
      header: "Type",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    });

    columns.splice(5, 0, {
      field: "record_name",
      header: "Record Name",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    });
  }

  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          mb: 1,
          gap: 1,
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "start", sm: "center" },
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        <Typography level="h2" component="h1">
          Hazards
        </Typography>

        {/* <Button
            color="primary"
            startDecorator={<Add />}
            size="sm"
            onClick={() => setVisible(true)}
          >Add</Button> */}
      </Box>

      <GenericTableView
        reload={reload}
        baseFilters={baseFilter}
        url="risk-hazard"
        columns={columns}
        contextItems={contextItems}
        addButton={site_id ? undefined : addButton}
        itemSelect={itemSelected}
        contextItemSelected={contextItemSelected}
      />

      <Dialog
        ref={dialog}
        header={site_id ? "View Hazard" : selectedRecord?.id ? "Update Hazard" : "Add Hazard"}
        visible={visible}
        style={{ width: "70vw" }}
        onHide={() => setVisible(false)}
      >
        <RiskHazardAdd
          setGlobalLoading={props.setGlobalLoader}
          setReload={setReload}
          reload={reload}
          id={selectedRecord?.id}
          uuid={uuid()}
          details={selectedRecord}
          setVisible={setVisible}
          toast={toast}
          client={client_id}
          site={site_id}
        />
      </Dialog>

      <ConfirmDialog />

      <Toast ref={toast} />
    </React.Fragment>
  );
}
